import React, { useState, useRef } from "react"
import ReactMarkdown from "react-markdown"
import { getImage } from "gatsby-plugin-image"
import { contactForm, formContain, form, formTop, formTopTitles, formTopInputs, left, leftTop, leftBottom, separator, right, formBottom, checkbox_container, checkmark } from "./contactForm.module.css"
import calendar from "./assets/calendar.png"
import ReCAPTCHA from 'react-google-recaptcha';

export default(props) => {
  const inputsName = JSON.parse(props.inputsName)
  const [recaptchaError, setRecaptchaError] = useState("")
  const [recaptchaToken, setRecaptchaToken] = useState(null)
  const recaptchaRef = useRef(null)

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token)
    if (token) {
      setRecaptchaError("")
    }
  }

  const handleSubmit = (e) => {
    if (!recaptchaToken) {
      e.preventDefault()
      setRecaptchaError("Veuillez valider le captcha")
      if (recaptchaRef.current) {
        recaptchaRef.current.reset()
      }
    }
  }

  return  (
  <div
    className={contactForm}
    style={{
    backgroundImage: `url(${props.background && getImage(props.background.gatsbyImageData)?.images?.fallback?.src})`
  }}>
    <div className={formContain}>
      <form
        className={form}
        method="post"
        action="https://comdeslezards-n8n-10adc5fb1055.herokuapp.com/webhook/1bcadd1f-110b-4e3b-99be-9ba5311ba20a"
        onSubmit={handleSubmit}>
        <input value={props.reponseContactOk} name="successMessage" type="hidden"/>
        <input value={props.reponseContactKo} name="failMessage" type="hidden"/>
        <div className={formTop}>
          <div className={formTopTitles}>
            <h3>Contact</h3>
            <h4>Villa Rossa Palombaggia</h4>
          </div>

          <div className={formTopInputs}>
            <div className={left}>
              <div className={leftTop}>
                <label htmlFor="arrivee">
                  {inputsName.arrive}
                  <input id="arrivee" name="to" type="date"/>
                  <img src={calendar} alt="arrivee"/>
                </label>
                <label htmlFor="depart">
                  {inputsName.depart}
                  <input id="depart" name="from" type="date"/>
                  <img src={calendar} alt="depart"/>
                </label>
              </div>
              <div className={leftBottom}>
                <label htmlFor="adultes">
                  {inputsName.adult}
                  <select id="adultes" name="adults">
                    <option value=''></option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </label>
                <label htmlFor="enfants">
                  {inputsName.child}
                  <select id="enfants" name="childs">
                    <option value=''></option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                  </select>
                </label>
              </div>
            </div>
            <div className={separator}></div>
            <div className={right}>
              <label htmlFor="nom">
                {inputsName.name}*
                <input id="nom" name="name" type="text" required/>
              </label>
              <label htmlFor="adresse">
                {inputsName.address}
                <input id="adresse" name="address" type="text"/>
              </label>
              <label htmlFor="telephone">
                {inputsName.tel}
                <input id="telephone" name="phone" type="tel"/>
              </label>
              <label htmlFor="email">
                {inputsName.mail}*
                <input id="email" name="email" type="email" required/>
              </label>
            </div>
          </div>

        </div>
        <div className={formBottom}>
          <textarea name="message" placeholder={inputsName.yourmessage} required></textarea>
          {/* <label className={checkbox_container}>
            <input type="checkbox" required />
            <span class={checkmark}></span>
            En soumettant ce formulaire, j'accepte que les informations saisies dans ce formulaire soient utilisées dans le cadre de la demande d'informations et de la relation commerciale qui peut en découler.
          </label> */}
          <div
            style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '1rem'
          }}>
            <ReCAPTCHA 
              ref={recaptchaRef}
              sitekey="6Le9wZMUAAAAAE8s2c3mN2xmmWkWigVCfES0kFr0"
              onChange={handleRecaptchaChange}
            />
            {recaptchaError && (
              <div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
                {recaptchaError}
              </div>
            )}
          </div>
          <button className="pinkButton" type="submit">{inputsName.send}</button>
          <ReactMarkdown source={props.description}/>
        </div>
      </form>
    </div>

  </div>
)
}